import Vue from 'vue'
if (window.sichern) {
  window.sichern.cdnURL = window.location.origin;
}
import App from './App.vue'
import router from './router'
import store from './vuex/store.js'
import { VueReCaptcha } from 'vue-recaptcha-v3'
// import 'sichern-dwt/dist/style.css'
import './plugins/vee-validate'
//import 'jquery';

// idiomas
import i18n from '@/plugins/i18n'
// fin idiomas

import 'vuetify/dist/vuetify.min.css'
import './plugins/vuetify'
import VueSweetalert2 from 'vue-sweetalert2'

// Plugin para manejar JWT desde iframe
import IframeMessageHandler from './plugins/iframeMessageHandler'

// Sichern UI Components
import ztComponents from '@sichern/ui-elements'
import '@sichern/ui-elements/dist/ztelements.css'
Vue.use(ztComponents)

// Import component
import VueLoading from 'vue-loading-overlay'
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css'

import '@/helpers/httpInterceptors'

Vue.use('VueLoading', VueLoading)
Vue.component('VueLoading', VueLoading)

// Vue Sweet Alert 2

const options = {
  confirmButtonColor: '#41b882',
  cancelButtonColor: '#ff7674'
}
Vue.use(VueSweetalert2, options)
// fin Vue Sweet Alert 2

//recaptcha v3

Vue.use(VueReCaptcha, {
  siteKey: window.sichern.recaptchaKey,
  loaderOptions: {
    autoHideBadge: true
  }
})

//fin recaptcha v3

// Registrar el plugin solo si estamos en un iframe
if (window.self !== window.top) {
  Vue.use(IframeMessageHandler);
} else {
  // Proporcionar mock para evitar errores
  Vue.prototype.$iframeMessages = {
    init: () => console.log('No disponible (no estamos en iframe)'),
    destroy: () => {},
    setAuthenticated: () => {},
    hasPendingMessages: () => false,
    isTokenValid: () => false,
    performanceSourceUrlData: () => '',
    getTokenPerformanceValue: () => null,
    sendAutoLoginError: () => {},
    setTokenValid: () => {}
  };
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
